var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSpecified && _vm.displayText)?_c('span',[_vm._v("\n  "+_vm._s(_vm.displayText)+"\n")]):_c('KEmptyPlaceholder')}
var staticRenderFns = []

export { render, staticRenderFns }